import { ChangeDetectionStrategy, Component, Input } from '@angular/core'
import { FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms'
import { MatButtonModule } from '@angular/material/button'
import { MatFormFieldModule } from '@angular/material/form-field'
import { MatInputModule } from '@angular/material/input'
import { MatSelectModule } from '@angular/material/select'
import { MatSliderModule } from '@angular/material/slider'
import { GbDashboardDialogService } from '@galabid/gb-dashboard/shared/utils'
import { TranslateModule } from '@ngx-translate/core'
import { GbDashboardSharedUiModule } from 'libs/gb-dashboard/shared/ui/src'
import {
  GbPresenterTeamFilterDialogComponent,
  GbPresenterTeamFilterDialogResult,
} from '../gb-presenter-team-filter-dialog/gb-presenter-team-filter-dialog.component'
import { GbPresenterToolsTextComponent } from '../gb-presenter-tools-text/gb-presenter-tools-text.component'

@Component({
  selector: 'gb-presenter-tools-team-scoring',
  imports: [
    ReactiveFormsModule,
    MatButtonModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatSliderModule,
    TranslateModule,
    GbDashboardSharedUiModule,
    GbPresenterToolsTextComponent,
  ],
  templateUrl: './gb-presenter-tools-team-scoring.component.html',
  styleUrl: './gb-presenter-tools-team-scoring.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GbPresenterToolsTeamScoringComponent {
  @Input() toolsFormGroup!: FormGroup

  hideFields = ['font_style', 'color']

  constructor(private gbDashboardDialogService: GbDashboardDialogService) {}

  get columnsControl(): FormControl {
    return this.toolsFormGroup.get('columns') as FormControl
  }

  get rowsControl(): FormControl {
    return this.toolsFormGroup.get('rows') as FormControl
  }

  get slideIntervalControl(): FormControl {
    return this.toolsFormGroup.get('slide_interval') as FormControl
  }

  get tablePrimaryColorControl(): FormControl {
    return this.toolsFormGroup.get('table_primary_color') as FormControl
  }

  get tableAccentColorControl(): FormControl {
    return this.toolsFormGroup.get('table_accent_color') as FormControl
  }

  get fontSizeControl(): FormControl {
    return this.toolsFormGroup.get('font_size') as FormControl
  }

  get borderWidthControl(): FormControl {
    return this.toolsFormGroup.get('border_width') as FormControl
  }

  get borderColorControl(): FormControl {
    return this.toolsFormGroup.get('border_color') as FormControl
  }

  get borderStyleControl(): FormControl {
    return this.toolsFormGroup.get('border_style') as FormControl
  }

  get opacityControl(): FormControl {
    return this.toolsFormGroup.get('opacity') as FormControl
  }

  get hiddenTeamsControl(): FormControl {
    return this.toolsFormGroup.get('hidden_teams') as FormControl
  }

  openFilterTeamsDialog(): void {
    const hiddenTeamUuids = (this.hiddenTeamsControl?.value || []) as string[]

    const dialogRef = this.gbDashboardDialogService.openDialog(GbPresenterTeamFilterDialogComponent, {
      width: '700px',
      maxWidth: '95vw',
      data: { hiddenTeamUuids },
    })

    dialogRef.afterClosed().subscribe((result: GbPresenterTeamFilterDialogResult | undefined) => {
      if (!result) return

      this.hiddenTeamsControl.setValue(result.hiddenTeamUuids)
      this.hiddenTeamsControl.markAsDirty()
      this.toolsFormGroup.markAsDirty()
    })
  }

  borderStyles = [
    { value: 'solid', label: 'PRESENTER.TEAM_SCORING_TOOLS.BORDER_STYLE_SOLID' },
    { value: 'dashed', label: 'PRESENTER.TEAM_SCORING_TOOLS.BORDER_STYLE_DASHED' },
    { value: 'dotted', label: 'PRESENTER.TEAM_SCORING_TOOLS.BORDER_STYLE_DOTTED' },
    { value: 'none', label: 'PRESENTER.TEAM_SCORING_TOOLS.BORDER_STYLE_NONE' },
  ]

  cardTypes = [
    { value: 'standard_table', label: 'PRESENTER.TEAM_SCORING_TOOLS.CARD_TYPE_STANDARD_TABLE' },
    { value: 'compact_table', label: 'PRESENTER.TEAM_SCORING_TOOLS.CARD_TYPE_COMPACT_TABLE' },
  ]

  transitions = [
    { value: 'fade-in', label: 'PRESENTER.TEAM_SCORING_TOOLS.TRANSITION_FADE_IN' },
    { value: 'scroll-top', label: 'PRESENTER.TEAM_SCORING_TOOLS.TRANSITION_SCROLL_TOP' },
  ]
}
